var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isApplePaySupported
      ? _c(
          "div",
          {
            attrs: { id: "nspay-apple-pay" },
            on: { click: _vm.processApplePayment },
          },
          [_c("div", { attrs: { id: "apple-pay-logo" } })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }